export const CINE_SPEEDS = ['0.5x', '1x', '1.5x', '2x', '3x'] as const;
export type CineSpeed = (typeof CINE_SPEEDS)[number];

export const FONT_SIZES = ['SMALL', 'MEDIUM', 'LARGE'] as const;
export type FontSize = (typeof FONT_SIZES)[number];

export const SESSION_DURATIONS = [
  '24_HOURS',
  '48_HOURS',
  '1_WEEK',
  '1_MONTH',
  'OFF',
] as const;
export type SessionDuration = (typeof SESSION_DURATIONS)[number];

export const INACTIVITY_TIMEOUTS = [
  '15_MINUTES',
  '30_MINUTES',
  '1_HOUR',
  '2_HOURS',
  'OFF',
] as const;
export type InactivityTimeout = (typeof INACTIVITY_TIMEOUTS)[number];

export const PANEL_LAYOUTS = [
  '1x1',
  '1x2',
  '1x3',
  '1x4',
  '2x1',
  '2x2',
  '2x3',
  '2x4',
  '3x1',
  '3x2',
  '3x3',
  '3x4',
  '4x1',
  '4x2',
  '4x3',
  '4x4',
] as const;
export type PanelLayout = (typeof PANEL_LAYOUTS)[number];

export type UnitSystem = 'METRIC' | 'IMPERIAL';

export interface Settings {
  uuid: string;
  user: string;
  darkMode: boolean;
  compactMode: boolean;
  fontSize: FontSize;
  cineSpeed: CineSpeed;
  collapsedAssignments: boolean;
  collapsedContentSection: boolean;
  collapsedMeasurementSection: boolean;
  poppedOutViewer: boolean;
  autoplay: boolean;
  autoSave: boolean;
  warnUnsavedChanges: boolean;
  panelLayout: PanelLayout;
  defaultTemplate: string;
  defaultWorksheet: string;
  credentialsLine?: string;
  reportSectionOrder?: string[] | null;
  rememberDeviceEnabled: boolean;
  sessionDuration: SessionDuration;
  inactivityTimeout: InactivityTimeout;
  showAddendumModal: boolean;
  copilotEnabled: boolean;
  unitSystem: UnitSystem;
  createdAt: string;
  updatedAt: string;
}

export const DEFAULT_SETTINGS: Settings = {
  uuid: '',
  user: '',
  darkMode: true,
  compactMode: false,
  fontSize: 'MEDIUM',
  cineSpeed: '1x',
  collapsedAssignments: false,
  collapsedContentSection: false,
  collapsedMeasurementSection: false,
  poppedOutViewer: false,
  autoplay: true,
  // AP-852: autosave stays off until a user opts in. The backend row is the
  // real source of truth (SettingsProvider merges remote over these), so the
  // matching `Setting.auto_save` default also has to be False.
  autoSave: false,
  warnUnsavedChanges: true,
  panelLayout: '1x1',
  defaultTemplate: '',
  defaultWorksheet: '',
  rememberDeviceEnabled: true,
  sessionDuration: '24_HOURS',
  inactivityTimeout: '15_MINUTES',
  showAddendumModal: true,
  copilotEnabled: true,
  unitSystem: 'METRIC',
  createdAt: '',
  updatedAt: '',
};
